var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 198,
    viewBox: "0 0 198 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.53 1.5H98.9797C152.567 1.5 196.01 44.9544 196.01 98.559V99.0089C196.01 152.613 152.567 196.068 98.9797 196.068H98.53C44.9423 196.068 1.5 152.613 1.5 99.0089V98.559C1.5 44.9544 44.9423 1.5 98.53 1.5Z",
    stroke: "white",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1025 65.6667C44.5007 63.251 43.2068 60.2608 43.2068 56.703C43.2068 53.1452 44.5076 50.0235 47.1025 47.6009C49.7043 45.1852 53.0535 43.9739 57.1569 43.9739C61.2603 43.9739 64.478 45.1852 67.0729 47.6009C69.6747 50.0166 70.9686 53.0552 70.9686 56.703C70.9686 60.3508 69.6678 63.251 67.0729 65.6667C64.4711 68.0823 61.1703 69.2937 57.1569 69.2937C53.1434 69.2937 49.7043 68.0823 47.1025 65.6667ZM68.7821 79.524V153.587H45.3864V79.524H68.7821Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M146.664 86.8403C151.763 92.3777 154.31 99.9779 154.31 109.654V152.279H132.091V112.658C132.091 107.779 130.824 103.985 128.299 101.286C125.773 98.5865 122.369 97.2299 118.106 97.2299C113.843 97.2299 110.439 98.5796 107.913 101.286C105.387 103.985 104.121 107.779 104.121 112.658V152.279H81.7705V79.3163H104.121V88.993C106.384 85.7674 109.436 83.2203 113.269 81.3445C117.103 79.4687 121.414 78.5342 126.209 78.5342C134.748 78.5342 141.571 81.3029 146.664 86.8334V86.8403Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/IN.3e90992afe79435f9588c157d5e4d0b2.svg";
export { ForwardRef as ReactComponent };